<div class="modal-content bary-add-or-update-address">
  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <p *ngIf="model.id" class="modal-title h4">{{ 'headband.modificationLabel' | translate }}</p>
    <p *ngIf="!model.id" class="modal-title h4">{{ 'headband.createLabel' | translate }}</p>
  </div>
  <form>
    <div class="modal-body">
      <div class="col-12" *ngIf="controlerDatePicker">
        <div class="alert alert-danger">
          <span>
            {{ controlerDatePicker }}
          </span>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <jhi-bary-input-textarea
            class="col-12"
            [control]="formGroup.controls.content"
            [label]="'modals.addOrUpdateHeadband.input.message' | translate"
            [id]="'additionals'"
            [maxLength]="170"
          ></jhi-bary-input-textarea>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <jhi-bary-date-picker
              [title]="'modals.addOrUpdateHeadband.input.startDate' | translate"
              [label]="'modals.addOrUpdateHeadband.input.startDate' | translate"
              [control]="formGroup.controls.startDate"
              [id]="id1"
              [disabled]="false"
              [forceRefreshOptions]="forceRefreshOptions"
              [isDisableWeekends]="false"
              (focusout)="onStartDateChange()"
            ></jhi-bary-date-picker>
          </div>
          <div class="col-6">
            <jhi-bary-date-picker
              [title]="'modals.addOrUpdateHeadband.input.endDate' | translate"
              [label]="'modals.addOrUpdateHeadband.input.endDate' | translate"
              [control]="formGroup.controls.endDate"
              [id]="id2"
              [disabled]="false"
              [forceRefreshOptions]="forceRefreshOptions"
              [isDisableWeekends]="false"
              (focusout)="onEndDateChange()"
            ></jhi-bary-date-picker>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <jhi-bary-input-multi-select [control]="formGroup.controls.transporters" [options]="optionsTransporter"></jhi-bary-input-multi-select>
          </div>
          <div class="col-6">
            <jhi-bary-input-select
              [id]="'headbandMessage'"
              [label]="'modals.addOrUpdateHeadband.input.typeMessage' | translate"
              [optionsWithMdbIcons]="_headbandMessageOptions"
              [control]="formGroup.controls.type"
              [placeholder]="model?.type?.valueOf()"
              [withMdbIcons]="true"
            >
            </jhi-bary-input-select>
          </div>
        </div>
      </div>
    </div>
    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        color="primary"
        class="mr-2"
        [label]="'modals.addOrUpdateHeadband.cancel' | translate"
        (clickEvent)="handleClick({ cancel: true })"
      ></jhi-bary-button>
      <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'modals.addOrUpdateHeadband.validation' | translate" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
